import {Directive, HostListener} from '@angular/core';

/**
 * Blocks all clipboard paste operations on the host element.
 *
 * Usage:
 * `<input appDisablePaste />`
 */
@Directive({
    selector: '[appDisablePaste]',
    standalone: false
})
export class DisablePasteDirective {
  /** Prevent Ctrl + V / Cmd + V / context-menu paste */
  @HostListener('paste', ['$event'])
  stopPaste(event: ClipboardEvent): void {
    event.preventDefault();
  }

  /** also stop Shift + Insert as a “paste” shortcut */
  @HostListener('keydown', ['$event'])
  stopShiftInsert(event: KeyboardEvent): void {
    if (event.key === 'Insert' && event.shiftKey) {
      event.preventDefault();
    }
  }
}
